import '../common/common.js'
import {MethodFromHashHelper} from "./MethodFromHashHelper.js";
import {OrderGlobals} from "./OrderGlobals.js";
import {Messages} from "./Messages.js";
import {ServicesPresenterBuilder, ServicesServerBoundaryBuilder, ServicesViewBuilder} from "./Services.js";
import {CloseParent} from './CloseParent.js'

MethodFromHashHelper.initialize();
OrderGlobals.initialize();
Messages.initialize();
ServicesServerBoundaryBuilder.initialize();
ServicesViewBuilder.initialize();
ServicesPresenterBuilder.initialize();
CloseParent.initialize();